export default Object.freeze({
  FormField: 1,
  Variable: 2,
});
